"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function createEntitiesMiddleware() {
    var flightIds = new Set();
    return function () {
        return function (next) { return function (action) {
            var _a, _b, _c, _d, _e, _f;
            switch (action.type) {
                case constants_1.REFETCH_MATCH_REQUEST: {
                    var matchId = action.payload.variables
                        .sportEventsIds[0];
                    if (matchId && !flightIds.has(matchId)) {
                        flightIds.add(matchId);
                        return next(action);
                    }
                    break;
                }
                case constants_1.REFETCH_MATCH_SUCCESS: {
                    var matchId = action.payload.result[0];
                    if (!matchId) {
                        flightIds.clear();
                        console.warn("Can't get matchId from action: " + action);
                    }
                    else {
                        flightIds.delete(matchId);
                    }
                    return next(action);
                }
                case constants_1.REFETCH_MATCH_FAIL: {
                    var matchId = (_f = (_e = (_d = (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.requestAction) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.variables) === null || _e === void 0 ? void 0 : _e.sportEventsIds) === null || _f === void 0 ? void 0 : _f[0];
                    if (!matchId) {
                        flightIds.clear();
                        console.warn("Can't get matchId from action: " + action);
                    }
                    else {
                        flightIds.delete(matchId);
                    }
                    return next(action);
                }
                default:
                    return next(action);
            }
        }; };
    };
}
exports.default = createEntitiesMiddleware;
//# sourceMappingURL=middleware.js.map